import React from "react";
import classes from "../helpCenter.module.css";
import cx from "classnames";

const CallButton = ({
  customClass,
  onClick,
  iconOnly = false,
  btxText = "Call"
}) => {
  return (
    <div className={cx(customClass, classes.call)} onClick={onClick}>
      <img src="/hire/headset-mic-new.svg" alt="mic" width={16} height={16} />
      {!iconOnly ? btxText : null}
    </div>
  );
};

export default CallButton;
